import PropTypes from "prop-types";

// MUI
import { Button, Typography } from "@mui/material";

// Icons
import Email from "@/assets/icons/svg/email.svg";

export default function SendEmailButton(props) {
	const { text = "", disabled = false, sx = null, onClick = () => {} } = props;
	return (
		<Button
			className="!absolute !right-[-12px] !top-1/4 !h-35px !w-[auto] !rounded !capitalize !p-0 !px-1 !bg-white"
			disabled={disabled || false}
			onClick={onClick}
			sx={sx}
		>
			<img src={String(Email)} className="!w-[20x] !h-[16px] !mr-3" />
			<Typography className={"!font-sans !text-[14.5px] !font-normal !text-primary"}>{text}</Typography>
		</Button>
	);
}
SendEmailButton.propTypes = {
	text: PropTypes.string,
	disabled: PropTypes.bool,
	sx: PropTypes.object,
	onClick: PropTypes.func,
};
